import cricketImg from "../assets/about-us/cricket.jpeg";
import badmintonImg from "../assets/about-us/badminton.jpeg";

function AboutPage() {
  return (
    <div style={styles.page}>

      {/* HERO */}
      <section style={styles.hero}>
        <div style={styles.heroContent}>
          <span style={styles.badge}>WHO WE ARE</span>

          <h1 style={styles.title}>
            About <span style={styles.gradientText}>Us</span>
          </h1>

          <p style={styles.subtitle}>
            Carolina Sports Club is your premier destination for sports training,
            youth development programs, and community athletic excellence.
          </p>
        </div>
      </section>

      {/* SECTION TITLE */}
      <section style={styles.sectionTitle}>
        <h2>
          Our Sports <span style={styles.gradientText}>Offerings</span>
        </h2>
      </section>

      {/* CRICKET */}
      <section style={styles.cardSection}>
        <div style={styles.card}>

          <div style={styles.cardRow}>

            {/* LEFT IMAGE */}
            <img
              src={cricketImg}
              alt="Cricket"
              style={styles.cardImage}
            />

            {/* RIGHT TEXT */}
            <div style={styles.cardContent}>
              <h3 style={styles.sportTitle}>🏏 Cricket</h3>
              <p style={styles.text}>
                Our cricket programs cater to all levels with professional coaching,
                structured training, and modern pitches. We focus on teamwork,
                discipline, and developing a strong sporting mindset.
              </p>
            </div>

          </div>

        </div>
      </section>

      {/* BADMINTON */}
      <section style={styles.cardSection}>
        <div style={styles.card}>

          <div style={styles.cardRow}>

            {/* LEFT TEXT */}
            <div style={styles.cardContent}>
              <h3 style={styles.sportTitle}>🏸 Badminton</h3>
              <p style={styles.text}>
                International-standard badminton courts with expert coaching for all
                skill levels. We help players improve technique, agility, and match
                performance in a structured environment.
              </p>
            </div>

            {/* RIGHT IMAGE */}
            <img
              src={badmintonImg}
              alt="Badminton"
              style={styles.cardImage}
            />

          </div>

        </div>
      </section>

    </div>
  );
}

const styles = {
  page: {
    width: "100%",
    boxSizing: "border-box", 
    overflowX: "hidden",     
    padding: "20px",
    color: "#fff",
  },

  /* HERO */
  hero: {
    textAlign: "center",
    padding: "15px 15px",
  },

  heroContent: {
    maxWidth: "900px",
    margin: "0 auto",
  },

  badge: {
    display: "inline-block",
    padding: "6px 14px",
    borderRadius: "20px",
    background: "rgba(0,255,150,0.1)",
    border: "1px solid rgba(0,255,150,0.3)",
    color: "#00f5a0",
    fontSize: "12px",
    letterSpacing: "2px",
    marginBottom: "10px",
  },

  title: {
    fontSize: "48px",
    marginBottom: "10px",
  },

  gradientText: {
    background: "linear-gradient(90deg, #00f5a0, #00d9f5)",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
  },

  subtitle: {
    color: "#e5e7eb",   // brighter than before
    fontSize: "16px",
    lineHeight: "1.6",
    maxWidth: "750px",
    margin: "0 auto",
  },

  /* SECTION TITLE */
  sectionTitle: {
    textAlign: "center",
    marginTop: "15px",
    marginBottom: "15px",
    fontSize: "28px",
  },

  /* CARDS */
  cardSection: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "15px",
  },

  card: {
    maxWidth: "900px",
    width: "100%",
    background: "rgba(0,40,70,0.6)",
    borderRadius: "20px",
    border: "1px solid rgba(0,255,150,0.2)",
    overflow: "hidden",   // ✅ important (makes image touch edges cleanly)
  },

  cardContent: {
    padding: "25px",
    lineHeight: "1.6",
  },

  cardRow: {
    display: "flex",
    alignItems: "stretch",
  },

  cardImage: {
    width: "40%",
    minHeight: "100%",
    objectFit: "cover",
    display: "block",
  },

  sportTitle: {
    fontSize: "22px",
    marginBottom: "10px",
    color: "#fff",
  },

  text: {
    color: "#d1d5db",
    fontSize: "15px",
  },
};

export default AboutPage;